export default __webpack_public_path__ + "static/media/play_store.ce08ab33.jpg";